import React from 'react';
import styled from 'styled-components';
import { useBoardStore } from '../../../boardStore';

const LoadNumber = styled.span`
    cursor:pointer;
    text-decoration: underline;
`;

export const MB_LOAD_NUMBER = ({currentLoadId}) => {
    const currentLoad = useBoardStore(s => (currentLoadId ? s.loadsById[currentLoadId] : null));
    const openPopupLoad = useBoardStore(s => s.openPopupLoad);
    let currrentLoadNumber = '-';
    if(currentLoad){
        currrentLoadNumber =  currentLoad.loadNumber;
    }
    
    // finalDestAddress
    return <div className="standard_text">
        {currrentLoadNumber === '-' ? 
            currrentLoadNumber :
            <LoadNumber
                className="loadNumberHoldingContainer"
                onClick={
                    ()=>{
                        openPopupLoad(currentLoadId);
                    }}
            >
                {currrentLoadNumber}
            </LoadNumber>
        }
       
        
    </div>
}